// Bascule « Liste | Carte » des écrans à carte (projets, affaires), choix retenu par écran dans le navigateur.
import { List as ListIcon, Map as MapIcon } from "lucide-react";
import { useTranslate } from "ra-core";

import type { ListView } from "./projectMapView";

export const MapFallback = () => (
  <div className="h-[calc(100vh-10rem)] min-h-[420px] animate-pulse rounded-[3px] bg-muted" />
);

/** Boutons à deux états, le choix courant en encre ; `listLabel` nomme la vue non cartographique. */
export const ViewToggle = ({
  view,
  onChange,
  floating,
  listLabel = "resources.projects.map.view_list",
}: {
  view: ListView;
  onChange: (view: ListView) => void;
  floating?: boolean;
  listLabel?: string;
}) => {
  const translate = useTranslate();
  const option = (value: ListView, Icon: typeof MapIcon, label: string) => (
    <button
      type="button"
      aria-pressed={view === value}
      onClick={() => onChange(value)}
      className={`inline-flex items-center gap-1.5 px-3 text-xs font-medium ${floating ? "h-10" : "h-8"} ${
        view === value
          ? "bg-ink text-background"
          : "text-muted-foreground hover:text-foreground"
      }`}
    >
      <Icon className="size-4" />
      {translate(label)}
    </button>
  );
  return (
    <div
      role="group"
      aria-label={translate("resources.projects.map.view")}
      className={`inline-flex overflow-hidden border border-border bg-card ${
        floating ? "rounded-full shadow-md" : "rounded-[3px]"
      }`}
    >
      {option("list", ListIcon, listLabel)}
      {option("map", MapIcon, "resources.projects.map.view_map")}
    </div>
  );
};
